import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost, dispatchFetchPut } from './ActionsUtil'
import {
  GET_CURRENT_PLAN_TABLE_BEGIN, GET_CURRENT_PLAN_TABLE_SUCCESS, GET_CURRENT_PLAN_TABLE_FAILURE,
  INSERT_PLAN_TABLE_DATA, POST_CREATE_PLAN_TABLE_BEGIN, POST_CREATE_PLAN_TABLE_SUCCESS, POST_CREATE_PLAN_TABLE_FAILURE,
  PUT_UPDATE_PLAN_TABLE_BEGIN, PUT_UPDATE_PLAN_TABLE_SUCCESS, PUT_UPDATE_PLAN_TABLE_FAILURE,
  GET_PLAN_TABLES_BEGIN, GET_PLAN_TABLES_SUCCESS, GET_PLAN_TABLES_FAILURE,
  POST_ADD_PLAN_BEGIN, POST_ADD_PLAN_SUCCESS, POST_ADD_PLAN_FAILURE,
  CLEAR_CURRENT_PLAN_TABLE_INFO,
  CLEAR_ADDED_PLANS
} from '../constants/ActionTypes'


const acGetCurrentPlanTableBegin = () => ({ type: GET_CURRENT_PLAN_TABLE_BEGIN, })
const acGetCurrentPlanTableSuccess = payload => ({
  type: GET_CURRENT_PLAN_TABLE_SUCCESS, payload: { response: payload }
})
const acGetCurrentPlanTableFailure = err => ({
  type: GET_CURRENT_PLAN_TABLE_FAILURE, payload: err
})

export const acGetCurrentPlanTable = () => {
  return dispatchFetchGet(
    `${URLS.PLAN.CURRENT_PLAN_TABLE}`,
    acGetCurrentPlanTableBegin,
    acGetCurrentPlanTableSuccess,
    acGetCurrentPlanTableFailure,
  )
}

export const acGetCustomerPlanTable = customerId => {
  return dispatchFetchGet(
    `${URLS.PLAN.TABLE}/${customerId}`,
    acGetCurrentPlanTableBegin,
    acGetCurrentPlanTableSuccess,
    acGetCurrentPlanTableFailure,
  )
}

const acGetPlanTablesBegin = () => ({ type: GET_PLAN_TABLES_BEGIN, })
const acGetPlanTablesSuccess = payload => ({
  type: GET_PLAN_TABLES_SUCCESS, payload: { response: payload }
})
const acGetPlanTablesFailure = err => ({
  type: GET_PLAN_TABLES_FAILURE, payload: err
})

export const acGetPlanTables = () => {
  return dispatchFetchGet(
    `${URLS.PLAN.TABLE}`,
    acGetPlanTablesBegin,
    acGetPlanTablesSuccess,
    acGetPlanTablesFailure,
  )
}

const acPostAddPlanToPlanTableBegin = () => ({ type: POST_ADD_PLAN_BEGIN, })
const acPostAddPlanToPlanTableSuccess = payload => ({
  type: POST_ADD_PLAN_SUCCESS, payload: { response: payload }
})
const acPostAddPlanToPlanTableFailure = err => ({
  type: POST_ADD_PLAN_FAILURE, payload: err
})

export const acPostAddPlanToPlanTable = (planTableId, planId, price) => {
  return dispatchFetchPost(
    `${URLS.PLAN.ADD_PLAN}`,
    {
      planTableId, planId, price
    },
    acPostAddPlanToPlanTableBegin,
    acPostAddPlanToPlanTableSuccess,
    acPostAddPlanToPlanTableFailure,
  )
}

const acPostCreatePlanTableBegin = () => ({ type: POST_CREATE_PLAN_TABLE_BEGIN, })
const acPostCreatePlanTableSuccess = payload => ({
  type: POST_CREATE_PLAN_TABLE_SUCCESS, payload: { response: payload }
})
const acPostCreatePlanTableFailure = err => ({
  type: POST_CREATE_PLAN_TABLE_FAILURE, payload: err
})

export const acPostCreatePlanTable = (planTable) => {
  return dispatchFetchPost(
    `${URLS.PLAN.TABLE}`,
    planTable,
    acPostCreatePlanTableBegin,
    acPostCreatePlanTableSuccess,
    acPostCreatePlanTableFailure,
  )
}

const acPutUpdatePlanTableBegin = () => ({ type: PUT_UPDATE_PLAN_TABLE_BEGIN, })
const acPutUpdatePlanTableSuccess = payload => ({
  type: PUT_UPDATE_PLAN_TABLE_SUCCESS, payload: { response: payload }
})
const acPutUpdatePlanTableFailure = err => ({
  type: PUT_UPDATE_PLAN_TABLE_FAILURE, payload: err
})

export const acPutUpdatePlanTable = (planTableId, planTable) => {
  return dispatchFetchPut(
    `${URLS.PLAN.TABLE}/${planTableId}`,
    planTable,
    acPutUpdatePlanTableBegin,
    acPutUpdatePlanTableSuccess,
    acPutUpdatePlanTableFailure,
  )
}

export const acInsertPlanTableData = (planTable) => ({ 
  type: INSERT_PLAN_TABLE_DATA, payload: planTable
 })
 
 export const acClearCurrentPlanTableInfo = () => ({ type: CLEAR_CURRENT_PLAN_TABLE_INFO })

 export const acClearAddedPlans = () => ({ type: CLEAR_ADDED_PLANS })